window.addEventListener("load", function () {

    


    // ===== STATE =====
    // Format: { day: { cau1: "yes"/"no", answers: [answerIndex] } }
    var answeredData = {};
    var currentDay = null;


    // ===== DATE HELPERS =====
    function parseDateOnly(dateStr) {
        if (!dateStr) return null;
        var parts = dateStr.split('-');
        if (parts.length !== 3) return null;
        var year = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var day = parseInt(parts[2], 10);
        if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
        return new Date(Date.UTC(year, month - 1, day));
    }

    function isPeriodLocked(day) {
        var openDateStr = periodOpenDates[day];
        if (!openDateStr) return false;
        var openDate = parseDateOnly(openDateStr);
        if (!openDate) return false;
        var today = new Date();
        var todayUTC = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
        return openDate.getTime() > todayUTC.getTime();
    }


    // ===== UPDATE LIST UI =====
    // Cập nhật trạng thái class cho từng li dựa theo answeredData và ngày mở
    function updateDayStatuses() {
        var items = document.querySelectorAll('#ddtk-ld-music .list-item li[data-day]');
        items.forEach(function (li) {
            var day = parseInt(li.getAttribute('data-day'), 10);

            // Xóa tất cả trạng thái động
            li.classList.remove('off', 'locked', 'received', 'fail');

            if (isPeriodLocked(day)) {
                li.classList.add('off', 'locked');
                return;
            }

            var dayData = answeredData[day];
            if (dayData && dayData.answers && dayData.answers.length > 0) {
                if (dayData.cau1 === 'yes') {
                    li.classList.add('received');
                } else {
                    li.classList.add('fail');
                }
            }
        });
    }


    // ===== RENDER QUESTION VÀO POPUP =====
    function renderQuestionInPopup(day) {
        var data = questionsData[day];
        if (!data) return;

        var titleEl = document.querySelector('#popup_question .js-question-title');
        var listEl = document.querySelector('#popup_question .js-question-list');
        if (!titleEl || !listEl) return;

        // Dừng audio đang phát
        var audio = document.getElementById('myAudio');
        if (audio) {
            audio.pause();
            audio.src = '';
        }

        // Cập nhật tiêu đề câu hỏi
        titleEl.innerHTML = data.title;

        // Kiểm tra ngày đã trả lời chưa
        var dayData = answeredData[day];
        var isAnswered = dayData && dayData.answers && dayData.answers.length > 0;
        var savedAnswerIndex = isAnswered ? dayData.answers[0] : null;
        var savedResult = isAnswered ? dayData.cau1 : null;

        // Render danh sách đáp án
        var html = '';
        data.answers.forEach(function (answer, aIndex) {
            var id = 'q-' + (aIndex + 1);
            var isChecked = isAnswered && savedAnswerIndex === aIndex;
            var isDisabled = isAnswered ? 'disabled' : '';

            var liClass = '';
            var btnExtraClass = '';
            if (isChecked) {
                btnExtraClass = ' active';
                if (savedResult === 'yes') liClass = 'yes';
                else if (savedResult === 'no') liClass = 'no';
            }

            html += '<li class="' + liClass + '" data-music="' + answer.music + '">';
            html += '<input type="radio" name="question" id="' + id + '" value="' + aIndex + '"'
                + (isChecked ? ' checked' : '') + ' ' + isDisabled + ' hidden>';
            html += '<a class="btn-question MS__hover' + btnExtraClass + '" href="#' + id + '">' + answer.text + '</a>';
            html += '<span class="stt">' + (aIndex + 1) + '</span>';
            html += '</li>';
        });
        listEl.innerHTML = html;

        // Cập nhật trạng thái nút submit
        updateSubmitButton(day);
    }


    // ===== SUBMIT BUTTON STATE =====
    function updateSubmitButton(day) {
        var submitBtn = document.querySelector('#popup_question .btn-submit');
        if (!submitBtn) return;
        var isAnswered = answeredData[day] && answeredData[day].answers && answeredData[day].answers.length > 0;
        submitBtn.classList.toggle('off', isAnswered);
        submitBtn.style.pointerEvents = isAnswered ? 'none' : '';
    }


    // ===== HIỂN THỊ POPUP INFORM =====
    function showInform(message) {
        var popup = document.getElementById('popup_inform_text');
        if (!popup) { alert(message); return; }
        var textEl = popup.querySelector('.pm__inform-text');
        if (textEl) textEl.innerHTML = message;
        popup.classList.add('active');
    }


    // ===== MỞ POPUP CÂU HỎI =====
    function openQuestionPopup(day) {
        if (isPeriodLocked(day)) {
            showInform('此活動尚未開放，請等待開放日期。');
            return;
        }
        currentDay = day;
        renderQuestionInPopup(day);
        var popup = document.getElementById('popup_question');
        if (popup) popup.classList.add('active');
    }


    // ===== CLICK BTN-CHOOSE =====
    document.querySelectorAll('#ddtk-ld-music .btn-choose').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var li = btn.closest('li[data-day]');
            if (!li) return;
            var day = parseInt(li.getAttribute('data-day'), 10);
            openQuestionPopup(day);
        });
    });


    // ===== CLICK BTN-QUESTION (chọn đáp án, không đổi URL) =====
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('#popup_question .btn-question');
        if (!btn) return;
        e.preventDefault();
        var href = btn.getAttribute('href');
        if (!href) return;
        var inputId = href.replace('#', '');
        var input = document.getElementById(inputId);
        if (input && !input.disabled) {                                                                                                                                                      
            //input.checked = true;                                                                                                                                                            
            var isActive = btn.classList.contains('active');                                                                                                                                 
            // Bỏ active + uncheck tất cả các btn khác                                                                                                                                     
            document.querySelectorAll('#popup_question .btn-question').forEach(function (b) {                                                                                              
                b.classList.remove('active');                                                                                                                                                
            });                                                                                                                                                                              
            document.querySelectorAll('#popup_question input[name="question"]').forEach(function (inp) {                                                                                     
                inp.checked = false;                                                                                                                                                         
            });                                                                                                                                                                              
            if (!isActive) {                                                                                                                                                          
                btn.classList.add('active');                                                                                                                                          
                input.checked = true;                                                                                                                                                 
            }                                                                                                                                                                         
        }
    });


    // ===== SUBMIT HANDLER (event delegation) =====
    document.addEventListener('click', function (e) {
        var submitBtn = e.target.closest('#popup_question .btn-submit');
        if (!submitBtn) return;
        e.preventDefault();

        if (!currentDay) return;

        // Kiểm tra đã chọn đáp án chưa
        var selected = document.querySelector('#popup_question input[name="question"]:checked');
        if (!selected) {
            showInform('請選擇一個答案！');
            return;
        }

        var answerIndex = parseInt(selected.value, 10);
        postResult(currentDay, answerIndex);
    });


    // ===== POST KẾT QUẢ =====
    function postResult(day, answerIndex) {
        var apiUrl = window.postAnswer;
        if (!apiUrl) return;

        // Chuyển index → chữ cái (0→A, 1→B, 2→C, 3→D)
        var letter = String.fromCharCode(65 + answerIndex);
        var postData = { round: 'day_' + day, answer: letter };

        $.ajax({
            url: apiUrl,
            type: 'POST',
            data: postData,
            success: function (response) {
                if (typeof window.onAnswerAjaxResponse === 'function') {
                    window.onAnswerAjaxResponse(response, 'POST');
                }
                // Lấy lại dữ liệu để cập nhật UI
                window.getAnsweredData();
                // Retry sau 300ms nếu server chưa xử lý xong
                setTimeout(function () {
                    if (!answeredData[day] || !answeredData[day].answers || answeredData[day].answers.length === 0) {
                        window.getAnsweredData();
                    }
                }, 300);
            },
            error: function (xhr, status, error) {
                if (typeof window.onAnswerAjaxResponse === 'function') {
                    window.onAnswerAjaxResponse({ success: false, error: error, status: status, responseText: xhr.responseText }, 'POST');
                }
            }
        });
    }


    // ===== GET DỮ LIỆU ĐÃ TRẢ LỜI =====
    // Expose ra global để trang chủ có thể gọi lại khi cần
    window.getAnsweredData = function () {
        var apiUrl = window.dataUrlAnswer || window.dataUrl || '../mock/get_data.html';
        if (!apiUrl) return;

        $.ajax({
            url: apiUrl,
            type: 'GET',
            dataType: 'json',
            success: function (response) {
                if (response === undefined || response === null) return;

                // Parse nếu server trả về string
                var parsedResponse = response;
                if (typeof response === 'string') {
                    try { parsedResponse = JSON.parse(response); } catch (e) { return; }
                }

                // Hỗ trợ cả { success: true, data: {...} } và object trực tiếp
                var answerData = null;
                if (parsedResponse.success && parsedResponse.data) {
                    answerData = parsedResponse.data;
                } else if (typeof parsedResponse === 'object' && parsedResponse !== null) {
                    answerData = parsedResponse;
                } else { return; }

                if (Array.isArray(answerData) && answerData.length > 0) {
                    answerData = answerData[0];
                }
                if (typeof answerData !== 'object' || answerData === null) return;

                // Parse từng key: "day_1|A|T"
                // T = đúng (yes), F = sai (no)
                Object.keys(answerData).forEach(function (key) {
                    var parts = key.split('|');
                    if (parts.length < 2) return;

                    var dayMatch = parts[0].match(/^day_(\d+)$/);
                    if (!dayMatch) return;
                    var day = parseInt(dayMatch[1], 10);

                    var answerLetter = parts[1].trim();
                    var answerIndex = null;
                    if (answerLetter) {
                        answerIndex = answerLetter.charCodeAt(0) - 65;
                        if (answerIndex < 0 || answerIndex > 3) answerIndex = null;
                    }

                    var result = null;
                    if (parts.length >= 3) {
                        result = parts[2].trim() === 'T' ? 'yes' : 'no';
                    }

                    answeredData[day] = { cau1: result, answers: [answerIndex] };
                });

                // Cập nhật trạng thái danh sách ngày
                updateDayStatuses();

                // Nếu popup đang mở, render lại với kết quả mới
                if (currentDay) {
                    renderQuestionInPopup(currentDay);
                }

                if (typeof window.onAnswerAjaxResponse === 'function') {
                    window.onAnswerAjaxResponse(response, 'GET');
                }
            },
            error: function (xhr, status, error) {
                if (typeof window.onAnswerAjaxResponse === 'function') {
                    window.onAnswerAjaxResponse({ success: false, error: error, status: status, responseText: xhr.responseText }, 'GET');
                }
            }
        });
    };


    // Callback sau khi submit + render xong (để trang chủ override nếu cần)
    // Signature: window.onAnswerSubmitted(day, answeredData[day])
    window.onAnswerSubmitted = window.onAnswerSubmitted || function (day, dayData) {};


    // ===== KHỞI TẠO =====
    updateDayStatuses();
    window.getAnsweredData();

});
